import PropTypes from 'prop-types'

const ItemResultPropTypes = {
  title: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
}

export default ItemResultPropTypes
